export enum TotalTypes {
    SUBTOTAL = 'subtotal',
    FEE = 'platform_fee',
    GRAND = 'grand_total',
    OFFER_ITEMS = 'total_content',
    ADDITIONAL_ITEMS = 'total_items',
    SUBTOTAL_AND_ADDONS = 'sub_&_addons',
    GRAND_MINUS_FEE = 'grand_minus_fee',
    GRAND_MINUS_CONNECTED_CLUB = 'grand_minus_cc',
    GRAND_SPENDING_OFFER = 'grand_total_spending',
}
